import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ 
  title, 
  subtitle, 
  backgroundImage, 
  ctaText = 'Get Started', 
  ctaLink = '/contact',
  secondaryCtaText,
  secondaryCtaLink,
  overlay = 0.5,
  height = 'large',
  align = 'center'
}) => {
  const defaultBg = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1920';
  
  return (
    <section 
      className={`hero hero-${height} hero-${align}`}
      style={{
        backgroundImage: `url(${backgroundImage || defaultBg})`
      }}
    >
      <div className="hero-overlay" style={{ opacity: overlay }}></div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title">{title}</h1>
          {subtitle && <p className="hero-subtitle">{subtitle}</p>}
          <div className="hero-buttons">
            <Link to={ctaLink} className="btn btn-primary">{ctaText}</Link>
            {secondaryCtaText && (
              <Link to={secondaryCtaLink || '/services'} className="btn btn-outline">
                {secondaryCtaText}
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="hero-scroll">
        <span></span>
      </div>
    </section>
  );
};

export default Hero;
